import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE, SETTING_KEYS } from 'utils/common/const';

const RulePage = () => {
  const [activeRuleTab, setActiveRuleTab] = useState('match');
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getAllSetting({ site: CONST_SITE.SC88 });
        if (!cancelled) {
          setDataSettings(res?.data || []);
        }
      } catch (e) {
        console.error('Error fetching settings:', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const tabs = [
    {
      key: 'match',
      icon: '/assets/images/tab/7.png',
      iconActive: '/assets/images/tab/7-1.png',
      alt: 'Dự đoán trận đấu'
    },
    {
      key: 'wc',
      icon: '/assets/images/tab/8.png',
      iconActive: '/assets/images/tab/8-1.png',
      alt: 'Dự đoán World Cup'
    }
  ];

  const renderSectionTitle = (title, isFull = false) => (
    <div className="w-full mt-4">
      <div className="flex items-center justify-center">
        <div
          className={twMerge(
            'bg-[#f27121] text-center text-white font-black uppercase',
            isFull
              ? 'w-full rounded-[6px] px-4 py-1 text-[18px] md:text-[20px] leading-[30px] md:leading-[34px]'
              : 'w-full md:w-[550px] max-w-full px-6 md:px-14 py-1.5 md:py-2 text-[14px] md:text-[22px] leading-[24px] md:leading-[32px] clip-title'
          )}
        >
          {title}
        </div>
      </div>
      {!isFull ? <div className="w-full h-px bg-[#f27121] mt-0.5" /> : null}
    </div>
  );

  const renderMatchRule = () => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content ?? ''
        }}
      />
    );
  };

  const renderWCRule = () => {
    const wcPrizeRows = [
      { category: 'Đội vô địch', vip0: 28, vip1: 58, vip6: 78, vip11: 108, vip16: 168 },
      { category: 'Vua phá lưới', vip0: 58, vip1: 98, vip6: 138, vip11: 188, vip16: 268 },
      { category: 'Cầu thủ xuất sắc', vip0: 28, vip1: 58, vip6: 88, vip11: 138, vip16: 188 },
      {
        category: 'Đội Châu Á vào sâu nhất',
        vip0: 28,
        vip1: 48,
        vip6: 78,
        vip11: 108,
        vip16: 178
      },
      {
        category: 'Đội ghi nhiều bàn nhất 1 trận',
        vip0: 48,
        vip1: 88,
        vip6: 138,
        vip11: 188,
        vip16: 268
      }
    ];

    return (
      <>
        {renderSectionTitle('Các hạng mục dự đoán')}
        <div className="mt-4 text-[#1f2937] text-[18px] leading-[1.4] space-y-2 px-3">
          <p>
            <span className="text-[#ea6418] font-black">Thời gian bắt đầu:</span> 00:00:00
            01/06/2026
          </p>
          <p>
            <span className="text-[#ea6418] font-black">Thời gian kết thúc:</span> 23:59:59
            11/06/2026
          </p>

          <p className="text-[#ea6418] font-black mt-4">1. DỰ ĐOÁN ĐỘI VÔ ĐỊCH</p>
          <p>
            Hội viên chọn 1 đội duy nhất trong danh sách các đội tuyển chính thức tham dự; kết quả
            lấy theo đội thắng trận chung kết do FIFA công bố (bao gồm hiệp phụ và loạt sút luân
            lưu).
          </p>

          <p className="text-[#ea6418] font-black mt-4">2. DỰ ĐOÁN VUA PHÁ LƯỚI</p>
          <p>
            Hội viên chọn 1 cầu thủ duy nhất trong danh sách các cầu thủ chính thức tham dự World
            Cup; kết quả lấy theo cầu thủ ghi nhiều bàn thắng nhất trong các trận đấu chính thức
            (bao gồm hiệp phụ, không tính loạt sút luân lưu) và theo công bố chính thức của FIFA
            (trường hợp đồng hạng cũng căn cứ theo kết quả FIFA).
          </p>

          <p className="text-[#ea6418] font-black mt-4">
            3. DỰ ĐOÁN CẦU THỦ XUẤT SẮC NHẤT (GOLDEN BALL)
          </p>
          <p>
            Hội viên chọn 1 cầu thủ duy nhất trong danh sách các cầu thủ chính thức tham dự World
            Cup; kết quả lấy theo danh hiệu Cầu thủ xuất sắc nhất (Golden Ball) do FIFA công bố
            chính thức.
          </p>

          <p className="text-[#ea6418] font-black mt-4">4. DỰ ĐOÁN ĐỘI CHÂU Á VÀO SÂU NHẤT</p>
          <p>
            Nội dung dự đoán: Dự đoán đội tuyển châu Á có thành tích tiến sâu nhất tại World Cup kỳ
            này. <br /> Lựa chọn dự đoán: Nền tảng chỉ hiển thị các đội tuyển châu Á chính thức tham
            dự World Cup kỳ này, người dùng chọn duy nhất 1 đội <br /> Quy tắc xác định: So sánh
            theo vòng đấu mà đội tuyển dừng chân cuối cùng; nếu có nhiều đội dừng ở cùng một vòng,
            thì so sánh điểm số vòng bảng; nếu điểm số vòng bảng vẫn bằng nhau, thì so sánh hiệu số
            bàn thắng bại vòng bảng. <br />
          </p>

          <p className="text-[#ea6418] font-black mt-4">
            5. DỰ ĐOÁN ĐỘI GHI NHIỀU BÀN NHẤT TRONG 1 TRẬN
          </p>
          <p>
            Hội viên chọn 1 đội duy nhất trong danh sách các đội ghi bàn nhiều nhất trong 1 trận đấu
            chính thức của World Cup 2026. Kết quả được xác định theo trận đấu có tổng số bàn thắng
            nhiều nhất trong thời gian thi đấu chính thức và hiệp phụ (không tính loạt sút luân
            lưu), căn cứ theo kết quả công bố chính thức của FIFA. Trường hợp có nhiều trận đấu có
            cùng số bàn thắng cao nhất, kết quả sẽ được xác định theo trận đấu diễn ra sớm nhất
            trong số các trận có cùng số bàn thắng đó.
          </p>
        </div>

        {renderSectionTitle('Cơ cấu giải thưởng', true)}
        <div className="mt-0.5  pb-1 overflow-x-auto">
          <div className="min-w-[920px] rounded-[8px] overflow-hidden border border-[#efb68f]">
            <div
              className="grid bg-[#f27121] text-white font-black text-center text-[18px] leading-[40px]"
              style={{ gridTemplateColumns: '2.2fr repeat(5, 1fr)' }}
            >
              <div>HẠNG MỤC</div>
              <div>VIP 0</div>
              <div>VIP 1+</div>
              <div>VIP 6+</div>
              <div>VIP 11+</div>
              <div>VIP 16+</div>
            </div>
            {wcPrizeRows.map((row, idx) => (
              <div
                key={row.category}
                className={twMerge(
                  'grid text-center text-[#111827] font-black text-[18px] leading-[48px]',
                  idx % 2 === 0 ? 'bg-white' : 'bg-[#f4e8de]'
                )}
                style={{ gridTemplateColumns: '2.2fr repeat(5, 1fr)' }}
              >
                <div className="px-2">{row.category}</div>
                <div>{row.vip0}</div>
                <div>{row.vip1}</div>
                <div>{row.vip6}</div>
                <div>{row.vip11}</div>
                <div>{row.vip16}</div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />
        <div
          className="mx-auto max-w-[1000px] mt-2 bg-white/95 border-2 border-solid shadow shadow-primary p-4 w-full md:pb-8 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#f27121',
            borderRadius: '1.5rem'
          }}
        >
          <style>
            {`
              .clip-title {
                clip-path: polygon(6% 0, 94% 0, 100% 100%, 0 100%);
              }
            `}
          </style>

          <div className="flex items-center justify-center gap-5 mt-2 mb-3">
            {tabs.map((tab) => {
              const isActive = activeRuleTab === tab.key;
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActiveRuleTab(tab.key)}
                  className="p-0 m-0 bg-transparent border-0 outline-none"
                >
                  <img
                    src={isActive ? tab.iconActive : tab.icon}
                    alt={tab.alt}
                    className="w-[170px] h-auto object-contain"
                  />
                </button>
              );
            })}
          </div>

          {activeRuleTab === 'match' ? renderMatchRule() : renderWCRule()}
        </div>
      </div>
    </div>
  );
};

export default RulePage;
